require('./RASuitabilityTestResult.scss');

// @vendors
const React = require('react');
const PropTypes = require('prop-types');
const moment = require('moment');

// @utilities
const { formatText, FormattedText } = require('core/i18n').i18n;
const DateHelper = require('utilities/dateHelper');

// @constants
const {
    DATE_FORMAT_COMPLETE,
    DATE_FORMAT_SLASHED_ES,
} = require('constants/index');

const {
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
} = require('constants/flagBasedFeatures');

// @commons
const RASuitabilityTestAccordion = require('../commons/RASuitabilityTestAccordion/RASuitabilityTestAccordion');
class RASuitabilityTestResult extends React.Component {
    buildSustainabilityProfile() {
        const {
            immFlagBasedFeatures,
            clientSustainabilityProfileDescription,
        } = this.props;
        if (
            clientSustainabilityProfileDescription &&
            immFlagBasedFeatures &&
            (immFlagBasedFeatures.get(
                SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
            ) ||
                immFlagBasedFeatures.get(
                    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
                ))
        ) {
            return <p>{clientSustainabilityProfileDescription}</p>;
        }
        return null;
    }

    render() {
        const {
            clientRiskProfile,
            date,
            clientRiskProfileDescription,
            productDescription,
        } = this.props;

        const lastResultInvestorLabel = formatText(
            'raSuitabilityTestResult-lastResultInvestorLabel',
        );
        const sustainabilityProfile = this.buildSustainabilityProfile();
        return (
            <article className="ra-suitability-test-result">
                <RASuitabilityTestAccordion
                    clientRiskProfile={clientRiskProfile}
                    bodyRiskProfileDescription={clientRiskProfileDescription}
                    productDescription={productDescription}
                    lastResultInvestorLabel={lastResultInvestorLabel}
                    sustainabilityProfile={sustainabilityProfile}
                />
                <h4 className="consult-mifid-view__date-title">
                    <FormattedText
                        value="consultMiFID-dateLastEvaluation"
                        format="uppercase"
                    />
                </h4>
                <div className="consult-mifid-view__info-bold">
                    {DateHelper.buildFormattedDate(
                        moment(date, DATE_FORMAT_SLASHED_ES),
                        DATE_FORMAT_COMPLETE,
                    )}
                </div>
            </article>
        );
    }
}

RASuitabilityTestResult.propTypes = {
    clientRiskProfile: PropTypes.string.isRequired,
    clientRiskProfileDescription: PropTypes.string.isRequired,
    date: PropTypes.object.isRequired,
    productDescription: PropTypes.string,
    clientSustainabilityProfileDescription: PropTypes.string,
    immFlagBasedFeatures: PropTypes.object,
};

RASuitabilityTestResult.defaultProps = {
    immFlagBasedFeatures: null,
    clientSustainabilityProfileDescription: null,
};

module.exports = RASuitabilityTestResult;
